import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { SettingsService } from "../../shared/services/settings.service";

@Component({
  selector: "new-ui-logout",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiLogoutComponent implements OnInit {
  constructor(private readonly settings: SettingsService) {}

  ngOnInit(): void {
    this.settings.logout();
  }
}
